import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

const TaxationAccountFailed = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const createAccountHandler = () => {
    navigate("/tax_account_dashboard/create_tax_account");
  };

  const dashboardHandler = () => {
    navigate("/tax_account_dashboard");
  };

  const buttonRows = [
    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: ICONS.ADD_BUTTON,
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--negative-bg)",
      },
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--negative-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
      },
    ],
  ];

  return (
    <StatusContainer
      status="error"
      title="Failed to create tax account."
      buttonRows={buttonRows}
      hoverOption="white"
    >
      <TabsWeapperSection title="Error details">
        <>
          <InfoCard
            bgColor="var(--negative-card)"
            rows={[
              {
                leftTitle: (() => {
                  if (!state) return "An unknown error occurred";
                  if (typeof state === "string") return state;
                  if (state?.error) return state.error;
                  if (state?.errors) {
                    return Object.values(state.errors).flat().join(", ");
                  }
                  return "An unknown error occurred";
                })(),
                leftSubTitle: "Error message",
              },
            ]}
          />
        </>
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default TaxationAccountFailed;
